// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2uMnC","signatureBlock":"Footer_signatureBlock__1l3Yp","signature":"Footer_signature__lrgq3"};